export enum ButtonCTAType {
  APP_EXCLUSIVE_CTA = 'APP_EXCLUSIVE_CTA',
  // @i18n-ignore
  B2B_SELF_SERVE = 'B2B_SELF_SERVE',
}
